<template>
    <!-- Takvimdeki renklerin hangi statuye karsilik geldigini gosterir. Renk statuden geliyor
         (Application.WorkOrderStatus.ColorId -> Application.Color), yani kutucuklar takvimdeki
         kayitlarla ayni kaynaktan besleniyor; elle eslestirme yok. -->
    <div class="work-order-status-legend" v-if="visibleStatuses.length">
        <span class="work-order-status-legend__item" v-for="status in visibleStatuses" :key="status.Id">
            <span class="work-order-status-legend__swatch" :style="{ backgroundColor: status.Color.Code }"></span>
            {{status.Name}}
        </span>
    </div>
</template>

<script>
export default {
  name: 'WorkOrderStatusLegend',
  props: {
    // Ekranda gercekten bulunan statuler; bos dizi ise efsane hic basilmaz.
    statusIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      statuses: [],
    };
  },
  async mounted() {
    await this.getStatuses();
  },
  methods: {
    async getStatuses() {
      try {
        const response = await this.$globalApiClient.workOrderStatus.workOrderStatusGetList({ workOrderSourceId: null });
        this.statuses = (response.data.Data || []).filter((status) => status.Color && status.Color.Code);
      } catch (e) {
        // Efsane yalnizca bilgilendirme; liste alinamazsa ekrani bozmadan gizli kalir.
        this.statuses = [];
      }
    },
  },
  computed: {
    visibleStatuses() {
      return this.statuses.filter((status) => this.statusIds.includes(status.Id));
    },
  },
};
</script>

<style scoped>
    .work-order-status-legend {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .work-order-status-legend__item {
        display: inline-flex;
        align-items: center;
        margin-right: 1.25rem;
        margin-bottom: 0.25rem;
        font-size: 0.85rem;
        color: #6d7d8f;
        white-space: nowrap;
    }

    .work-order-status-legend__swatch {
        width: 0.75rem;
        height: 0.75rem;
        margin-right: 0.35rem;
        border-radius: 2px;
        flex: none;
    }
</style>
